module.exports = __webpack_public_path__ + "fonts/medium.4073d40.woff2";